@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@adv-mt/mt-empty-case-default/lib/index';
@import '~@adv-mt/mt-hero-basic/lib/index';
@import '~@adv-mt/mt-button-sticky/lib/index';
@import '~@adv-mt/mt-list-compare/lib/index';
@import '~@adv-mt/mt-list-makes/lib/index';
@import '~@adv-mt/mt-list-marketed-versions/lib/index';
@import '~@adv-mt/mt-list-model-details/lib/index';
@import '~@adv-mt/mt-list-models/lib/index';
@import '~@adv-mt/mt-list-pagination/lib/index';
@import '~@adv-mt/mt-list-tag-chips/lib/index';
@import '~@adv-mt/mt-list-tagcloud/lib/index';
@import '~@adv-mt/mt-list-related-ads/lib/index';
@import '~@adv-mt/mt-gallery-basic/lib/index';
@import '~@adv-mt/mt-list-versions/lib/index';
@import '~@adv-mt/mt-media-dimensions/lib/index';
@import '~@adv-mt/mt-media-size/lib/index';
@import '~@adv-mt/mt-modal-add-vehicle/lib/index';
@import '~@adv-mt/mt-navigation-breadcrumb/lib/index';
@import '~@adv-mt/mt-panel-add-vehicles/lib/index';
@import '~@adv-mt/mt-panel-best-offers/lib/index';
@import '~@adv-mt/mt-panel-equipment/lib/index';
@import '~@adv-mt/mt-panel-stores/lib/index';
@import '~@adv-mt/mt-search-header/lib/index';
@import '~@adv-mt/mt-search-sidebar/lib/index';
@import '~@adv-mt/mt-shared-section-wrapper/lib/index';
@import '~@adv-mt/mt-technical-detail-make-title/lib/index';
@import '~@adv-mt/mt-technical-details-panel-links/lib/index';
@import '~@adv-mt/mt-technical-details-panel-slider/lib/index';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-atom-table/lib/index';
@import '~@s-ui/react-molecule-checkbox-field/lib/index';

$op-mediasize-img: 0.16;
$p-media-size: $p-base * 8;
$h-media-size-frame-img: 93px;
$w-sidebar: 270px;
$maw-content: 652px;

.mt-TechnicalDetailsPanelLinks-item {
  min-width: 0;
}

.mt-TechnicalDetailsVehicle {
  &-contentWrapper {
    background-color: $c-white;
    border-radius: $bdrs-l;
    box-shadow: $bxsh-m;
    padding: $p-l;
    @include media-breakpoint-up(m) {
      display: grid;
      gap: $m-l;
      &--withSidebar {
        grid-template-columns: minmax(auto, $maw-content) $w-sidebar;
      }
    }
  }

  &-modelDetails {
    &-info {
      color: $c-gray-dark-1;
      margin-bottom: 0;
    }
  }

  &-panelEquipment {
    &-info {
      color: $c-gray-dark-1;
      margin-bottom: 0;
    }
  }

  &-sidebar {
    margin-top: $m-l;
    padding: 0;

    &Content {
      @include media-breakpoint-up(m) {
        padding: $p-m 0;
        position: sticky;
        top: 0;
      }
    }
  }

  &Size {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: $m-giant + $m-xxxl;
    padding-top: $p-l;
    @include media-breakpoint-up(m) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: center;
      padding: $p-l $p-media-size 0;
    }

    &-image {
      opacity: $op-mediasize-img;
      height: $h-media-size-frame-img;
    }

    &-side {
      padding: 0 $p-xxl;
    }
    &-front {
      padding: 0 $p-xxxl;
      @include media-breakpoint-up(m) {
        padding: 0;
      }
    }
  }
}
